import { Box } from "@chakra-ui/react";

interface Props {
  children: React.ReactNode;
}

export default function MainContent({ children }: Props) {
  return (
    <Box padding="4" flex={1}>
      {children}
    </Box>
  );
}
